var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(!_vm.isPlatformOwner)?[_c('dashboard-core-app-bar'),_c('dashboard-core-drawer')]:_vm._e(),_c('dashboard-core-view')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }